// src/api/Apis.js
import axios from 'axios';

// Set base URL and auth header globally
axios.defaults.baseURL = "https://api.nurexify.com/";
axios.defaults.headers.common['authentication'] = "21e52971e010cbc03a84cc834ebc27e3";

// Function to get static page list
export const getStaticPageList = async () => {
  try {
    const response = await axios.get("api/elastic/getBlogList?lt=500");
    return response;
  } catch (error) {
    console.error("Error fetching static pages:", error);
    throw error;
  }
};
export const saveContact = async (input_data) => {
  try {
    const response = await axios.post("api/customer/saveContact",input_data);
    return response;
  } catch (error) {
    console.error("Error fetching saveContact:", error);
    throw error;
  }
};
